// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchInput_inputContainer__A9VWb {
  display: flex;
  position: relative; }

.searchInput_form__MRpho {
  width: 100%; }
  .searchInput_form_input__S6Gxu {
    border: none;
    appearance: none;
    padding: 4px 0px;
    padding-right: 24px;
    width: 100%;
    font-size: 14px;
    outline: none;
    border-radius: 0;
    color: var(--HightEmphasis);
    background: linear-gradient(90deg, #222, #222) left bottom/0 2px no-repeat, linear-gradient(90deg, #212121, #212121) left bottom/100% 1px no-repeat, linear-gradient(90deg, #fafafa, #fafafa) left bottom/100% 2px no-repeat; }
  .searchInput_form_input__S6Gxu:focus::placeholder {
    color: transparent; }
  .searchInput_form_input__S6Gxu::placeholder {
    color: var(--MediumEmphasis);
    transition: color 0.3s ease; }
  .searchInput_form_submit__J0TiH {
    cursor: pointer;
    background: none;
    border: none;
    position: absolute;
    right: 0; }
`, "",{"version":3,"sources":["webpack://./src/components/searchInput/searchInput.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,kBAAkB,EAAA;;AAGpB;EACE,WAAW,EAAA;EACX;IACE,YAAY;IAIZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,4NAEyE,EAAA;EAE3E;IACE,kBAAkB,EAAA;EAEpB;IACE,4BAA4B;IAC5B,2BAA2B,EAAA;EAE7B;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ,EAAA","sourcesContent":["@import 'src/styles/media.scss';\n@import 'src/styles/fonts.scss';\n\n.inputContainer {\n  display: flex;\n  position: relative;\n}\n\n.form {\n  width: 100%;\n  &_input {\n    border: none;\n    -webkit-appearance: none;\n    -ms-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    padding: 4px 0px;\n    padding-right: 24px;\n    width: 100%;\n    font-size: 14px;\n    outline: none;\n    border-radius: 0;\n    color: var(--HightEmphasis);\n    background: linear-gradient(90deg, #222, #222) left bottom/0 2px no-repeat,\n      linear-gradient(90deg, #212121, #212121) left bottom/100% 1px no-repeat,\n      linear-gradient(90deg, #fafafa, #fafafa) left bottom/100% 2px no-repeat;\n  }\n  &_input:focus::placeholder {\n    color: transparent;\n  }\n  &_input::placeholder {\n    color: var(--MediumEmphasis);\n    transition: color 0.3s ease;\n  }\n  &_submit {\n    cursor: pointer;\n    background: none;\n    border: none;\n    position: absolute;\n    right: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputContainer": `searchInput_inputContainer__A9VWb`,
	"form": `searchInput_form__MRpho`,
	"form_input": `searchInput_form_input__S6Gxu`,
	"form_submit": `searchInput_form_submit__J0TiH`
};
export default ___CSS_LOADER_EXPORT___;
